<template>
	<div>
		<Loader :show="loading" type="inline" />

		<div class="d-flex justify-content-end">
			<div class="btn btn-primary" @click="open()">Crear validador</div>
		</div>

		<table class="table table-sm" v-if="!loading">
			<tr class="table-head">
				<td>Nombre</td>
				<td>Contacto</td>
				<td></td>
			</tr>

			<tr v-for="item of list" :key="item.id">
				<td>
					<div class="tc">
						<span class="bolder">{{ item.name }} {{ item.lastname }}</span>
					</div>
				</td>
				<td>
					<div class="tc">
						<span class="bolder">{{ item.email }}</span>
						<span v-if="item.phone">{{ item.phone.national }}</span>
					</div>
				</td>
				<td class="text-right">
					<b-dropdown no-caret right class="btn-dropdown-dots ml-2">
						<template v-slot:button-content><i class="icon icon-dot-3"></i></template>
						<b-dropdown-item @click="open(item)">Editar</b-dropdown-item>
						<b-dropdown-item @click="resendAccessEmail(item)">Reenviar claves de acceso</b-dropdown-item>
						<b-dropdown-item @click="deletePrompt(item)" class="delete-item">Eliminar</b-dropdown-item>
					</b-dropdown>
				</td>
			</tr>
		</table>

		<div class="alert alert-default text-center mt-3" v-if="!loading && list.length == 0">
			No se han encontrado validadores
		</div>

		<b-modal id="validatorModal" :title="title" no-close-on-backdrop hide-footer>
			<Loader :show="saving" />

			<FormulateForm v-if="!loading" v-model="form" ref="form" @submit="save">
				<div class="row row-xs mb-4">
					<div class="col col-md-6 ">
						<FormulateInput label="Nombre" name="name" validation-name="Nombre" validation="required" />
					</div>
					<div class="col col-md-6 ">
						<FormulateInput
							label="Apellido"
							name="lastname"
							validation-name="Apellido"
							validation="required"
						/>
					</div>
				</div>

				<FormulateInput label="Email" name="email" type="email" validation-name="Email" validation="required" />

				<FormulateInput
					label="Teléfono"
					type="phone"
					name="phone"
					validation-name="Teléfono"
					validation="optional|^phone"
				/>

				<div class="mt-3 alert alert-default">
					Se le enviará un correo electrónico con las claves e instrucciones de acceso a la app de validación.
				</div>

				<hr />

				<div class="d-flex justify-content-between mt-4">
					<FormulateInput type="button" data-ghost @click="close">Cancelar</FormulateInput>
					<FormulateInput type="button" disabled v-if="saving"
						>Guardando <span class="loader"
					/></FormulateInput>
					<FormulateInput type="submit" label="Guardar" v-else />
				</div>
			</FormulateForm>
		</b-modal>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "Validators",

	props: {
		canCreate: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			list: [],
			loading: true,
			title: "Crear validador",
			action: "create",
			form: {
				id: null,
				name: null,
				lastname: null,
				phone: null,
				email: null
			}
		}
	},

	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},

	methods: {
		async open(item) {
			console.log(item)
			this.loading = true

			if (item) {
				this.title = "Editar validador"
				this.action = "update"

				this.form = {
					id: item.id,
					name: item.name,
					lastname: item.lastname,
					phone: item.phone,
					email: item.email
				}
			} else {
				this.form = {
					id: null,
					name: null,
					lastname: null,
					phone: null,
					email: null
				}
			}

			this.$bvModal.show("validatorModal")
			this.loading = false
		},
		close() {
			this.$bvModal.hide("validatorModal")
			this.form = {
				id: null,
				name: null,
				lastname: null,
				phone: null,
				email: null
			}
		},
		async save() {
			if (!this.saving) {
				this.saving = true
				let data = {
					name: this.form.name,
					lastname: this.form.lastname,
					phone: this.form.phone,
					email: this.form.email
				}

				if (this.action == "create") await this.create(data)
				if (this.action == "update") await this.update(data)
				this.load()
				this.saving = false
			}
		},

		async create(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: ValidatorInput!) {
							validatorCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Validador creado correctamente")
					this.close()
					return data.userCreate
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		async update(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: ValidatorInput!) {
							validatorUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.form.id,
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Validador editado correctamente")
					this.close()
					return data.userUpdate
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		async resendAccessEmail(item) {
			this.loading = true
			let data = {
				notificationWelcomeSended: false
			}
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: ValidatorInput!) {
							validatorUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: item.id,
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Datos de acceso enviados")
					this.loading = false
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
					this.loading = false
				})
		},

		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String) {
							validators(take: $take, skip: $skip, search: $search) {
								data {
									id
									name
									lastname
									phone {
										countryCode
										national
										international
										type
										validated
									}
									email
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.list = data.validators.data
					this.pagination.pageInfo = data.validators.pageInfo
					this.loading = false
				})
		},

		deletePrompt(item) {
			this.$dialog
				.confirm(`¿Está seguro que desea eliminar el validador ${item.name} ${item.lastname}?`)
				.then(() => {
					this.delete(item)
				})
		},

		delete(item) {
			// item.loading = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!) {
							validatorDelete(id: $id) {
								id
							}
						}
					`,
					variables: {
						id: item.id
					}
				})
				.then(() => {
					this.$toast.success("Validador eliminado correctamente")
					this.load()
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					item.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.item {
	padding: 8px 12px;
	border-bottom: 1px solid #f3f3f3;
	cursor: pointer;
	border-radius: 4px;
	margin-top: 4px;

	h5 {
		font-size: 1.1rem;
		font-weight: 500;
		margin: 0px;
	}

	p {
		font-size: 0.85rem;
		line-height: 0.9rem;
		color: #999;
		margin: 0px;
		font-weight: 300;
	}

	&:hover {
		background-color: #f3f3f3;
	}
}
</style>
